import React from "react";
import PersonPinCircleOutlinedIcon from "@mui/icons-material/PersonPinCircleOutlined";
import useTranslations from "../useTranslations";

export const SkiDataView = ({ data: d }) => {
  const t = useTranslations();
  return (
    <div className="columns mb-5">
      <span className="column is-narrow icon is-hidden-mobile">
        <PersonPinCircleOutlinedIcon />
      </span>
      <div className="column is-4">
        <table className="table is-narrow">
          <tbody>
            <tr>
              <th>{t["dataLocation"]}</th>
              <td>{`${d.loc.lat}, ${d.loc.lon}`}</td>
            </tr>
            <tr>
              <th>{t["dataAltitude"]}</th>
              <td>{`${d.loc.altitude} m`}</td>
            </tr>
            <tr>
              <th>{t["dataTemperature"]}</th>
              <td>{`${d.weather.temp}`} °C</td>
            </tr>
            <tr>
              <th>{t["dataWind"]}</th>
              <td>{`${d.weather.wind.speed} m/s ${d.weather.wind.dir}`}</td>
            </tr>
            <tr>
              <th>{t["dataHours"]}</th>
              <td>{d.distance.hours} h</td>
            </tr>
            <tr>
              <th>{t["dataDistance"]}</th>
              <td>
                {d.distance.today.toFixed(1)} km (
                {d.distance.avgToday.toFixed(1)} km/h){" "}
              </td>
            </tr>
            <tr>
              <th>{t["dataCumulativeDistance"]}</th>
              <td>{d.distance.cumulative.toFixed(0)} km</td>
            </tr>
            <tr>
              <th>{t["dataLeft"]}</th>
              <td>{d.distance.left.toFixed(0)} km</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};
